import { Component, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  FormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { NavigationEnd, Router } from '@angular/router';
import { confirmedValidator } from 'src/app/shared/directives/confirmed.validator';
import { CommonService } from 'src/app/shared/services/angular-service/common.services';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';
import { UserService } from 'src/app/shared/services/node-api/user.service';
import { LocalStorageService } from 'src/app/shared/services/angular-service/local-storage.service';
import { ToastService } from 'src/app/shared/services/angular-service/toast.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {
  changePasswordForm: UntypedFormGroup;
  plans = ['Free Plan'];
  plan: string;
  email: string;
  companyList: any;
  urlPosition: string;
  userName: string;

  constructor(
    private loginSignupService: LoginSignupService,
    private userService: UserService,
    private router: Router,
    private fb: UntypedFormBuilder,
    private toastService: ToastService,
    private commonService: CommonService,
    private localStorage: LocalStorageService
  ) {
    this.changePasswordForm = this.fb.group(
      {
        password: ['', [Validators.required, Validators.minLength(8)]],
        newpassword: ['', [Validators.required, Validators.minLength(8)]],
        confirmpassword: ['', [Validators.required, Validators.minLength(8)]],
      },
      {
        validator: confirmedValidator('newpassword', 'confirmpassword'),
      }
    );
  }

  ngOnInit(): void {
    this.userName = this.loginSignupService.getUserSession().user.name;
    this.urlPosition = this.router.url;
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.urlPosition = this.router.url;
      }
    });
    this.email = this.loginSignupService.getUserSession().user.email;
    this.plan = this.loginSignupService.getUserSession().user.plan;
  }

  changePassword() {
    let currentOption;
    currentOption = {
      password: this.changePasswordForm.value.password,
      newpassword: this.changePasswordForm.value.newpassword,
      email: this.email,
    };
    // console.log(currentOption)
    this.loginSignupService.changePasswordFirebase(this.changePasswordForm.value.newpassword).then((data => {
      // console.log(data)
      this.userService.changePassword(currentOption).then(
        (data: any) => {
          if (
            data.message !== undefined &&
            data.message !== '' &&
            data.message !== null
          ) {
            this.toastService.addSingle('error', 'Error', data.message);
          } else {
            this.toastService.addSingle(
              'success',
              'Successfully',
              'You have successfully change your passowrd.'
            );
            this.logout();
            this.router.navigateByUrl('/user/login');
          }
        },
        (err) => {
          console.log("err", err)
          this.toastService.addSingle('error', 'Error', err.error.message);
        }
      );
    })
    ).catch(err => {
      console.log("err", err)
      this.toastService.addSingle('error', 'Error', err.error.message);
    })
  }

  logout() {
    this.companyList = JSON.parse(
      this.localStorage.getItem('compareCompanyList')
        ? this.localStorage.getItem('compareCompanyList')
        : '[]'
    );
    this.companyList.forEach((element) => {
      this.commonService.addToCompareList(element);
    });
    this.loginSignupService.userLogout();
    this.router.navigate(['/']);
  }
}
